<template>
    <div>
      <Header class="inline-block">
        <template v-slot:title><span class="text-lg capitalize">Educación</span></template>
      </Header>
      <div class="relative pl-px overflow-hidden timeline-educate">
          <div v-for="(educate, index) in data" :key="index" class="pl-6 mb-10 border-l-3 border-tertiary">
              <p><small> {{ educate.from }} - {{ educate.to }}, {{educate.status}}</small></p>
              <p class="text-2xl font-semibold">{{ educate.university }}</p>
              <p class="text-base"> {{educate.name}} </p>
          </div>
      </div>
    </div>
</template>

<script>
import data from '../data/education'
import Header from './Header';

export default {
  components: {
    Header
  },
  data() {
    return {
      data: data
    }
  } 
};
</script>

<style scoped>
  .timeline-educate:before {
    content:'';
    position: absolute;
    width: 0;
    left: 2px;
    top: 0;
    bottom: 0;
    border-right: 1px solid color-mod(var(--color-tertiary) a(70%));
  }
  .timeline-educate:after {
    content:'';
    position: absolute;
    width: 5px;
    height: 5px;
    left: 0;
    margin-top: -5px;
    background-color: var(--color-tertiary);
  }
</style>
